module.exports = __webpack_public_path__ + "static/media/analytic-add-on.2d986818.png";